var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.609 76.232a1.5 1.5 0 0 0-2.034.603 21.778 21.778 0 0 1-19.15 11.399c-12.009 0-21.778-9.77-21.778-21.778a21.793 21.793 0 0 1 9.435-17.944 1.5 1.5 0 1 0-1.703-2.47 24.795 24.795 0 0 0-10.731 20.414c0 13.663 11.115 24.778 24.778 24.778a24.779 24.779 0 0 0 21.787-12.967 1.499 1.499 0 0 0-.603-2.034Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.27 75.571a1.5 1.5 0 0 0-1.91-.921l-8.036 2.806a1.229 1.229 0 0 1-1.52-.657l-8.76-19.674a5.108 5.108 0 0 0-4.664-3.029H40.304a2.114 2.114 0 0 1-2.1-1.948l-.658-8.783h19.552a1.5 1.5 0 1 0 0-3H37.321l-1.034-13.818a8.161 8.161 0 1 0-3.08-.951l2.005 26.775c.198 2.649 2.435 4.725 5.092 4.725H59.38c.831 0 1.586.49 1.924 1.25l8.76 19.675c.691 1.554 2.248 2.502 3.875 2.502a4.15 4.15 0 0 0 1.374-.233l8.035-2.806a1.5 1.5 0 0 0 .922-1.911Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.fcff8ba955a0d68205a29be02fb2cd84.svg";
export { ForwardRef as ReactComponent };